import type {FlagDef} from './types';

export const LD_FLAGS: {[key: string]: FlagDef<boolean>} = {
  MAINTENANCE_MODE_BRIDGE: {
    key: 'maintenance_mode_bridge',
    defaultValue: false,
  },
  PATHFINDER_DATA_ACCESS: {
    key: 'pathfinder_data_access',
    defaultValue: false,
  },
  SECURITY_IDLE_TIMER: {
    key: 'security_idle_timer',
    defaultValue: false,
  },
  SENTRY_DEBUG: {
    key: 'sentry_debug',
    defaultValue: false,
  },
  REVERT_DOCUMENT: {
    key: 'revert_document',
    defaultValue: false,
  },
  STAFF_NOTIFICATIONS: {
    key: 'staff_notifications',
    defaultValue: false,
  },
  SHOW_EMR_LINK_IN_BRIDGE: {
    key: 'show_emr_link_in_bridge',
    defaultValue: false,
  },
  STORY_MANAGER: {
    key: 'story_manager',
    defaultValue: false,
  },
  PEERS_DOCUMENTATION: {
    key: 'peers_documentation',
    defaultValue: false,
  },
  ENABLE_UNASSIGNED_USERS: {
    key: 'enable_unassigned_users',
    defaultValue: false,
  },
  ENABLE_PUBLIC_INVITES: {
    key: 'enable_public_invites',
    defaultValue: false,
  },
  EMR_MANAGED_USERS: {
    key: 'emr_managed_users',
    defaultValue: false,
  },
  RESOURCE_ADMIN: {
    key: 'resource_admin',
    defaultValue: false,
  },
  CONTACT_NOTES: {
    key: 'contact_notes',
    defaultValue: false,
  },
  DOCUMENTATION_V2: {
    key: 'documentation_v2',
    defaultValue: false,
  },
  SIGNAL_BRIDGE: {
    key: 'signal_bridge',
    defaultValue: false,
  },
};
